<div class="modal-header" *ngIf="isDialog">
    <h5 class="modal-title">
        <span>CUTSHEET IMAGES</span>
    </h5>
    <span class="fa fa-close" aria-label="Close" (click)="activeModal.close()"></span>
</div>
<div class="modal-body w-100 text-center">
    <div class="row g-4">
        <!-- Main Image Section -->
        <div class="col-md-5">
            <div *ngIf="images['image1']?.url" (drop)="onDrop($event,1)" (dragover)="onDragOver($event)">
                <div class="main-image-container">
                    <div class="main-image-header" *ngIf="!readOnly">Main Image
                        <div class="delete-button  button" (click)="deleteImage(1)">X</div>
                    </div>
                    <div class="main-image-body">
                        <img id="mainImage" [src]="sanitizeImage(images['image1']?.url)" alt="Test Title 2">
                    </div>
                </div>
                <p *ngIf="readOnly" id="mainImageTitle" class="main-image-title">{{images['image1']?.title}}</p>
                <p *ngIf="!readOnly" id="mainImageTitle" class="main-image-title">
                    <input type="text" class="title-input" [ngModel]="images['image1']?.title"
                        (ngModelChange)="titleChanged = true ; images['image1'].title = $event">
                </p>
            </div>
            <div *ngIf="!images['image1']?.url && !readOnly" (drop)="onDrop($event,1)" (dragover)="onDragOver($event)">
                <div class="gallery-item gallery-item-placeholder" (click)="fileInput.click()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                </div>
                <input type="file" accept="image/*" #fileInput hidden (change)="onImageUpload($event, 1)" />
                <p class="gallery-title">{{images['image1']?.title}}</p>
            </div>
            <div *ngIf="!images['image1']?.url && readOnly" (drop)="onDrop($event,1)" (dragover)="onDragOver($event)">
                <div class="gallery-item gallery-item-placeholder" (click)="fileInput.click()">

                </div>
                <p class="gallery-title">{{images['image1']?.title || 'N/A'}}</p>
            </div>
        </div>

        <!-- Image Gallery Section -->
        <div class="col-md-7">
            <div class="row g-3" id="imageGallery">
                <ng-container *ngFor="let i of [2,3,4,5,6,7]">
                    <div *ngIf="images['image'+ i]?.url" (drop)="onDrop($event,i)" (dragover)="onDragOver($event)" class="col-6 col-sm-4">
                        <div>
                            <div class="gallery-item">
                                <img [src]="sanitizeImage(images['image'+ i]?.url)">
                                <div class="overlay" *ngIf="!readOnly">
                                    <div class="sam">
                                        <div class="button" (click)="setMainImage(i)">
                                            SET AS MAIN
                                        </div>
                                    </div>
                                    <div class="delete-button button" (click)="deleteImage(i)">
                                        X
                                    </div>
                                </div>
                            </div>
                            <p *ngIf="readOnly" class="gallery-title">{{images['image' + i]?.title}}</p>
                            <p *ngIf="!readOnly" class="gallery-title">
                                <input type="text" class="title-input" [ngModel]="images['image' + i]?.title"
                                    (ngModelChange)="titleChanged = true ;images['image' + i].title = $event">
                            </p>
                        </div>
                    </div>
                    <div *ngIf="!images['image'+ i]?.url && !readOnly" (drop)="onDrop($event,i)" (dragover)="onDragOver($event)" class="col-6 col-sm-4">
                        <div>
                            <div class="gallery-item gallery-item-placeholder" (click)="fileInput.click()">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 4v16m8-8H4" />
                                </svg>
                            </div>
                            <input type="file" accept="image/*" #fileInput hidden (change)="onImageUpload($event, i)" />
                            <p class="gallery-title">{{images['image' + i]?.title}}</p>
                        </div>
                    </div>
                    <div *ngIf="!images['image'+ i]?.url && readOnly" (drop)="onDrop($event,i)" (dragover)="onDragOver($event)" class="col-6 col-sm-4">
                        <div>
                            <div class="gallery-item">

                            </div>
                            <p class="gallery-title">{{images['image'+i]?.title || 'N/A'}}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer w-100 d-flex flex-column" *ngIf="isDialog">
    <div class="w-100 action-buttons d-flex justify-content-end gap-1">
        <button type="button" class="btn btn-primary" (click)="activeModal.close('cancel')">Cancel</button>
        <button [ngClass]="{
              'disabled-control':readOnly || !isValueChanged}" type=" button" class="btn btn-primary"
            (click)="save()">Save</button>
    </div>
</div>